import * as React from 'react';
import axios, { AxiosResponse } from 'axios';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container footer-inner">                
                <div className="row">
                    <div className="col-lg-4">
                        <a target="_blank" href="https://bilh.org/">
                            <img className="logo" src="https://images.squarespace-cdn.com/content/v1/611d64626683587e449adb05/1631625013148-IFCNKYM9XOMYDIC0UQFL/BILH_System_Lnd_RGB_Left_Margin.png" alt="Beth Israel Lahey Health Primary Care" />
                        </a>
                    </div>
                    <div className="col-lg-8 align-self-center align-items-end">
                        {/*<a onClick={(e) => exit(e)} className="btn btn-outline-primary btn-exit-tool ml-auto" href="https://www.bilh.org/"><svg className="exitDoor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 216.38 316.4"><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path d="M215.11,156l-25.17-14.53a2.55,2.55,0,0,0-3.82,2.21v5H174.3V29.33a5.14,5.14,0,0,0-5.14-5.14H130.85a5.14,5.14,0,0,0-5.15,5.14V34a5.15,5.15,0,0,0,5.15,5.15h23.31a5.14,5.14,0,0,1,5.14,5.14V148.7H142.37a2.07,2.07,0,0,0-2.06,2.07v14.86a2.07,2.07,0,0,0,2.06,2.07H159.3V272.07a5.14,5.14,0,0,1-5.14,5.14H130.85a5.15,5.15,0,0,0-5.15,5.15v4.71a5.14,5.14,0,0,0,5.15,5.14h38.31a5.14,5.14,0,0,0,5.14-5.14V167.7h11.82v5a2.55,2.55,0,0,0,3.82,2.21l25.17-14.53A2.55,2.55,0,0,0,215.11,156Z" /><path d="M110.87.15,6.34,20.54A7.85,7.85,0,0,0,0,28.24V289.86a7.84,7.84,0,0,0,6.46,7.72L111,316.28a7.85,7.85,0,0,0,9.23-7.73V7.85A7.84,7.84,0,0,0,110.87.15Zm-10.2,167.54a9.49,9.49,0,1,1,9.49-9.49A9.49,9.49,0,0,1,100.67,167.69Z" /></g></g></svg>&nbsp; Exit Online Appointment Scheduling</a>*/}
                    </div>
                </div>
                
                <hr className="mt-4 mb-5" />
                
                <div className="row mb-5">
                    <nav className="footer-nav footer-nav-secondary col">
                        <a target="_blank" href="https://bilh.org/notice-privacy-practices">Notice of Privacy Practices</a>
                        <a target="_blank" href="https://bilh.org/terms-conditions/website-policies">Terms of Use</a>
                        <a target="_blank" href="https://bilh.org/non-discrimination-notice">Non-Discrimination Notice</a>
                        <a target="_blank" href="https://bilh.org/terms-conditions/texting-terms-conditions">Text-Messaging Terms and Conditions</a>
                        <a target="_blank" href="http://bilh.org/-/media/files/bilh/balance-billing-notice.pdf">Balance Billing Notice</a>
                    </nav>
                </div>
                
                <div className="row">
                    <div className="col-lg-8 mb-3 align-self-center">
                        <span className="copyright">&copy; 2022 Beth Israel Lahey Health. All rights reserved.</span>
                    </div>

                    <div className="col-lg-4 mb-3">
                        <nav className="social-links">
                            <a target="_blank" href="https://www.facebook.com/BethIsraelLaheyHealth/">
                                <img src="img/icon-facebook.svg" alt="Facebook" />
                            </a>
                            <a target="_blank" href="https://mobile.twitter.com/bethisraellahey">
                                <img src="img/icon-twitter.svg" alt="Twitter" />
                            </a>
                            <a target="_blank" href="https://www.instagram.com/bethisraellaheyhealth/" >
                                <img src="img/icon-instagram.svg" alt="Instagram" />
                            </a>
                            <a target="_blank" href="https://www.youtube.com/channel/UCU2yjviREXHV8SCMaOLcdlg">
                                <img src="img/icon-youtube.svg" alt="YouTube" />
                            </a>
                            <a target="_blank" href="https://www.linkedin.com/company/beth-israel-lahey-health/">
                                <img src="img/icon-linkedin.svg" alt="LinkedIn" />
                            </a>
                        </nav>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;